/**
 * Collection ESM entry point. Loaded on template.name == 'collection'.
 *
 * AI: Entirely written by AI
 * Date: 2026-05-05
 * Model: Claude Opus 4.7
 *
 * [EntryCollection]
 */

import { log } from './log.js';
import './collection.js';
import './collection-infinite-scroll.js';

log('[App] entry-collection loaded');

